
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  cosmeticTissueDispenser: {
    id: "CosmeticTissueDispenser.cosmeticTissue",
    defaultMessage: "Cosmetic tissue dispenser",
  },
  paperTowelDispenser: {
    id: "PaperTowelDispenser.paperTowelDispenser",
    defaultMessage: "Paper towel dispenser",
  },
  cosmeticTissueDispenserWithout: {
    id: "CosmeticTissueDispenser.without",
    defaultMessage: "without paper tissue dispenser",
  },
  cosmeticTissueDispenserWith: {
    id: "CosmeticTissueDispenser.with",
    defaultMessage: "with paper tissue dispenser",
  },
  cosmeticTissueDispenserSquare: {
    id: "CosmeticTissueDispenserSquare.square",
    defaultMessage: "square (with Gelcoat) 127 x 38 mm",
  }, 
  cosmeticTissueDispenserSquareModel: {
    id: "CosmeticTissueDispenserSquareModel.squaremodel",
    defaultMessage: "(for cosmetic tissue dispenser „model number“)",
  }, 
  cosmeticTissueDispenserPosition: {
    id: "CosmeticTissueDispenserPosition.position",
    defaultMessage: "(Position between the troughs)",
  },

  cutOutLabelCustomRound: {
    id: "CutOutLabel.CustomRound",
    defaultMessage: "Round discharge (with gelcoat)",
  },
  cutOutLabelCustomSquare: {
    id: "CutOutLabel.CustomSquare",
    defaultMessage: "Square discharge (with gelcoat)",
  },
  cutOutLabelRoundSleeve: {
    id: "CutOutLabel.roundSleeve",
    defaultMessage: "Round discharge with discharge sleeve",
  },
  cutOutLabelSquareSleeve: {
    id: "CutOutLabel.squareSleeve",
    defaultMessage: "Square discharge with discharge sleeve",
  },
  cutOutLabelRoundBasket: {
    id: "CutOutLabel.roundBasket",
    defaultMessage: "Round discharge with basket",
  },
  cutOutLabelRoundRail: {
    id: "CutOutLabel.roundRail",
    defaultMessage: "Round discharge with rail system",
  },
  cutOutLabelSquareBasket: {
    id: "CutOutLabel.squareBasket",
    defaultMessage: "Square discharge with basket",
  },
  cutOutLabelSquareRail: {
    id: "CutOutLabel.squareRail",
    defaultMessage: "Square discharge with rail system",
  },
  cutOutLabelRoundSleeveBasket: {
    id: "CutOutLabel.roundSleeveBasket",
    defaultMessage: "Round discharge with discharge sleeve and basket",
  },
  cutOutLabelRoundSleeveRail: {
    id: "CutOutLabel.roundSleeveRail",
    defaultMessage: "Round discharge with discharge sleeve and rail",
  },
  cutOutLabelSquareSleeveBasket: {
    id: "CutOutLabel.squareSleeveBasket",
    defaultMessage: "Square discharge with discharge sleeve and basket",
  },
  cutOutLabelSquareSleeveRail: {
    id: "CutOutLabel.squareSleeveRail",
    defaultMessage: "Square discharge with discharge sleeve and rail",
  },
  cutOutLabelFlap: {
    id: "CutOutLabel.flap",
    defaultMessage: "Discharge flap",
  },
  cutOutLabelFlapBasket: {
    id: "CutOutLabel.flapBasket",
    defaultMessage: "Discharge flap with basket",
  },
  cutOutLabelFlapRail: {
    id: "CutOutLabel.flapRail",
    defaultMessage: "Discharge flap with rail system",
  },
  cutOutLabelProvider: {
    id: "CutOutLabel.provider",
    defaultMessage: "Paper towel dispenser",
  },
  cutOutLabelCosmetic: {
    id: "CutOutLabel.cosmetic",
    defaultMessage: "Cosmetic tissue dispenser",
  },
  cutOutLabelCustomInputDiameter: {
    id: "CutOutLabelCustomInput.diameter",
    defaultMessage: "Diameter",
  },
  cutOutLabelCustomInputWidth: {
    id: "CutOutLabelCustomInput.width",
    defaultMessage: "Width",
  },
  cutOutLabelCustomInputDepth: {
    id: "CutOutLabelCustomInput.depth",
    defaultMessage: "Depth",
  },
  cutOutLabelSelect: {
    id: "CutOutLabelSelect.select",
    defaultMessage: "Please Select",
  },
  cutOutLabelNone: {
    id: "CutOutLabelNone.none",
    defaultMessage: "No cut-out selected",
  },
  cutOutDisposalsDefaultsWithout: {
    id: "CutOutDisposalsDefaultsWithout.without",
    defaultMessage: "without cut-out",
  },
  cutOutDisposalsDefaultsWith: {
    id: "CutOutDisposalsDefaultsWith.with",
    defaultMessage: "with cut-out",
  },
  soapDispenserHoleLabelWithout: {
    id: "SoapDispenserHoleLabelWithout.without",
    defaultMessage: "without",
  },
  soapDispenserHoleLabelSD80: {
    id: "SoapDispenserHoleLabelSD80.sd80",
    defaultMessage: "for soap dispenser SD80",
  },
  soapDispenserHoleLabelSD100: {
    id: "SoapDispenserHoleLabelSD100.sd100",
    defaultMessage: "for soap dispenser SD100",
  },
  soapDispenserHoleLabel25: {
    id: "SoapDispenserHoleLabel25.dispensers",
    defaultMessage: "for dispensers provided by others (Ø 25 mm)",
  },
  tapHoleWithout: {
    id: "TapHoleWithout.taphole",
    defaultMessage: "without drilling",
  },
  tapHoleWithoutDrilling: {
    id: "TapHoleWithoutDrilling.tapholedrilling",
    defaultMessage: "with drilling (Ø 35 mm)",
  },
  towelRailWithout: {
    id: "TowelRailWithout.towelrailwithout",
    defaultMessage: "without cut-out",
  },
  towelRailWith: {
    id: "TowelRailWithout.towelrailwith",
    defaultMessage: "with cut-out",
  },
  square: {
    id: "SquareCustom.square",
    defaultMessage: "square",
  },
  round: {
    id: "RoundCustom.round",
    defaultMessage: "round",
  },
});

export default MESSAGES;